import { scaleLinear } from 'd3-scale';
import { IScaler, IScaleSettings } from '../models/interfaces';

export class ScaleSettings implements IScaleSettings {
    // properties
    domain: { min: number; max: number } = { min: 0, max: 1 };
    range: { min: number; max: number } = { min: 0, max: 1 };
}

export class Scaler implements IScaler {
    // Data Members

    private scaleSettingsX: ScaleSettings;
    private scaleSettingsY: ScaleSettings;

    // Constructor

    constructor(scaleSettingsX: ScaleSettings, scaleSettingsY: ScaleSettings) {
        this.scaleSettingsX = scaleSettingsX;
        this.scaleSettingsY = scaleSettingsY;

        this._onX = scaleLinear()
            .domain([scaleSettingsX.domain.min, scaleSettingsX.domain.max])
            .range([scaleSettingsX.range.min, scaleSettingsX.range.max]);

        this._onY = scaleLinear()
            .domain([scaleSettingsY.domain.min, scaleSettingsY.domain.max])
            .range([scaleSettingsY.range.min, scaleSettingsY.range.max]);
    }

    // Properties

    private _onX;
    get onX() {
        return this._onX;
    }

    private _onY;
    get onY() {
        return this._onY;
    }
}
